module.exports = __webpack_public_path__ + "img/macroglobal.63ad6aa5.png";